
<template>
   <div>
      <router-view></router-view>
   </div>
</template>

<script>
   export default {

      data () {
         return {
         }
      },

      computed: {
         // 'nutrieduc', 'shdl'
         platform () {
            return this.$store.getters.platform
         },
      },

      mounted: function() {
         if (this.platform) {
            this.$router.push(`/news/${this.platform}`)
         }
      },

      watch: {
         // necessary at first launch
         'platform': function (newVal, oldVal) {
            console.log('platform changed from/to', oldVal, newVal)
            if (newVal) {
               this.$router.push(`/news/${newVal}`)
            }
         },
      },
   }
</script>



// WEBPACK FOOTER //
// News.vue?77b53314